module.exports = __webpack_public_path__ + "img/weatherpedia-pwa6.520a509d.jpg";